export default {
    'search.tip': 'Quick Search',
    'search.producttip': 'Product Name'
}